import { poppins } from "@/components/common/fonts";
import { Modal, Button } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  align-self: center;
  overflow: hidden;
  box-sizing: border-box;
  /* padding: 26px 30px; */

  /* For below 768px screen width Jimmy */
  @media screen and (max-width: 768px) {
    min-width: 330px;
    overflow-y: scroll;
  }
`;

export const StyledCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HighlightDiv = styled.div`
  width: 280px;
  height: 32px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  background-color: #eaeaea;
  color: #4276ee;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;

  font-family: ${poppins.string};

  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  & > * {
    flex: 1 1 100px;
  }

  overflow-x: auto;

  @media screen and (max-width: ${({theme}) => theme.screenMD}px) {
    flex-direction: column;
    overflow-x: visible;

    & > * {
      flex-basis: auto;
    }
  }
`

export const StyledSwitchButton = styled(Button)`
`